import { Chip, DotsMenu } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles, useTheme } from 'react-jss';
import { Colors, Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  memberListItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase * 2,

    minHeight: theme.height.large,
    borderBottom: {
      color: theme.colors.grayBorder,
      style: 'solid',
      width: 1,
    },
  },
  exp: {
    ...theme.fonts.label,
    color: theme.colors.redAccessible,
    marginLeft: theme.marginBase,
  },
  expDate: {
    ...theme.fonts.caption,
    color: theme.colors.inkSecondary,
  },
  email: {
    ...theme.fonts.body,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 1,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase * 2,
  },
}));

interface Props {
  email: string | React.ReactNode;
  children?: React.ReactNode;
  expired?: boolean;
  expDate?: string;

  chip?: {
    color: Colors;
    text: string;
  };
}

export const MemberItem = ({
  email,
  children,
  chip,
  expired,
  expDate,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  return (
    <li className={classes.memberListItem}>
      <div className={classes.email}>{email}</div>

      {!!expired && (
        <div className={classes.exp}>
          {t(`teamInformations.invitationStatus.${true ? 'expired' : 'sent'}`)}
        </div>
      )}
      {!expired && expDate && (
        <div className={classes.expDate}>
          {t('teamInformations.expDate', { date: expDate })}
        </div>
      )}

      {!!chip && <Chip color={chip.color}>{chip.text}</Chip>}
      <DotsMenu horizontal>{children}</DotsMenu>
    </li>
  );
};
